import { Button, Popconfirm, Table, Tag, Typography } from "antd";
import {
  diaEHora,
  estadoDaCamera,
  mascararEndereco,
  textoDaDecisao,
} from "./textos";

const { Text } = Typography;

export default function CamerasTab({
  cameras,
  aguardando,
  onAbrir,
  onAdicionar,
  onEditar,
  onRemover,
  onDecidir,
  decidindoId,
}) {
  const agora = new Date();
  const colunas = [
    {
      title: "Câmera",
      key: "camera",
      render: (_, c) => (
        <>
          <Text strong>{c.nome}</Text>
          <div>
            <Text
              type="secondary"
              style={{
                fontSize: 12,
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                wordBreak: "break-all",
              }}>
              {mascararEndereco(c.endereco)}
            </Text>
          </div>
        </>
      ),
    },
    {
      title: "Estado",
      key: "estado",
      width: 280,
      render: (_, c) => {
        const estado = estadoDaCamera(c.reportada);
        const r = c.reportada;
        const detalhe =
          estado.frase ||
          (r?.estado === "parada" && r?.conectada ? "conexão de pé" : null) ||
          (r?.codec
            ? `${r.codec} ${r.largura}x${r.altura}${
                r.kbpsMedido ? ` · ${r.kbpsMedido} kbps` : ""
              }`
            : null);
        return (
          <>
            <Tag color={c.ativa ? estado.cor : "default"}>
              {c.ativa ? estado.rotulo : "Desativada"}
            </Tag>
            {detalhe && (
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {detalhe}
                </Text>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Último segmento",
      key: "ultimo",
      width: 130,
      render: (_, c) => diaEHora(c.reportada?.ultimoSegmentoEm, agora),
    },
    {
      title: "Gravação",
      key: "gravacao",
      width: 220,
      render: (_, c) => (
        <>
          <Text type="secondary">{textoDaDecisao(c.gravacao, agora)}</Text>
          {aguardando && c.gravacao?.origem === "remota" && (
            <div>
              <Text type="warning" style={{ fontSize: 12 }}>
                Aguardando o gateway
              </Text>
            </div>
          )}
        </>
      ),
    },
    {
      title: "Re-encode",
      dataIndex: "reencode",
      width: 100,
      render: (valor) => (valor ? "Sim" : "Não"),
    },
    {
      title: "",
      key: "acoes",
      width: 220,
      render: (_, c) => (
        <span
          style={{ whiteSpace: "nowrap" }}
          onClick={(e) => e.stopPropagation()}>
          <Button
            size="small"
            loading={decidindoId === c.id}
            onClick={() => onDecidir(c, !c.gravacao?.parada)}>
            {c.gravacao?.parada ? "Retomar" : "Parar"}
          </Button>
          <Button type="link" onClick={() => onEditar(c)}>
            Editar
          </Button>
          <Popconfirm
            title="Remover esta câmera?"
            description="O gateway para de gravá-la na próxima atualização."
            okText="Remover"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
            onConfirm={() => onRemover(c)}>
            <Button type="link" danger>
              Remover
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 12,
        }}>
        <Text type="secondary">
          Câmeras cadastradas para o gateway desta filial
        </Text>
        <Button
          type="primary"
          style={{ marginLeft: "auto" }}
          onClick={onAdicionar}>
          Adicionar câmera
        </Button>
      </div>
      <Table
        rowKey="id"
        size="middle"
        pagination={false}
        columns={colunas}
        dataSource={cameras}
        onRow={(c) => ({
          onClick: () => onAbrir(c),
          style: { cursor: "pointer" },
        })}
        locale={{ emptyText: "Nenhuma câmera cadastrada" }}
      />
    </>
  );
}
